import React, { useEffect, useState, useCallback } from 'react';
import { Modal } from 'pageFramework/modals/modal';
/*import { DeleteConfirmationModal } from 'pageFramework/modals';*/
import { WindowDetailsView } from './windowDetailsView';
import { useApiService, useDataApiState, useVoidApiState } from 'hooks';
import { CalendarWindows } from 'types';
import { createCalendarScheduleService } from 'services';
import ErrorSummary from 'components/common/errorSummary';
import LoadingIndicator from 'components/loadingIndicator';
//import { Button, DeleteButton } from 'pageFramework/uiControls/buttons';
//import { ActionBar } from 'pageFramework/uiControls/layouts';
//import { RecurrencePatternEditModal } from './recurrencePatternEditModal';

interface WindowDetailsModalProps {
	show: boolean;
	selectedId: number | null;
	calendarId: number;
	onClose: () => void;
}

export const WindowDetailsModal: React.FC<React.PropsWithChildren<WindowDetailsModalProps>> = (props) => {
	const { selectedId, calendarId, show, onClose } = props;
	const [details, setDetails] = useDataApiState<CalendarWindows>(true);
	const [isEditMode, setIsEditMode] = useState<boolean>(false);
	//const [error, setError] = useState<string | null>(null)
	//const [confirmWindowDelete, setConfirmWindowDelete] = useState(false);
	//const [confirmRecurrencePatternDelete, setConfirmRecurrencePatternDelete] = useState(false);
	//const [deleteDetails, setDeleteDetails] = useVoidApiState();

	const calendarScheduleService = useApiService(createCalendarScheduleService);

	useEffect(() => {
		if (selectedId) {
			setIsEditMode(false);
			calendarScheduleService.getWindowDetails(selectedId, setDetails);
		}
	}, [selectedId, setDetails]);

	//const openRecurrencePatternEdit = useCallback(() => {
	//	setIsEditMode(true);
	//}, [setIsEditMode]);

	//const closeEditing = useCallback(() => {
	//	setIsEditMode(false);
	//	onClose();
	//}, [setIsEditMode])

	//const handleWindowDeleteClick = useCallback(() => {
	//	setConfirmWindowDelete(true);
	//}, []);

	//const handleWindowDeleteConfirm_Cancel = useCallback(() => {
	//	setConfirmWindowDelete(false);
	//}, []);

	//const handleWindowDeleteConfirm_Confirmed = useCallback(async () => {
	//	const success = await calendarScheduleService.deleteWindow(selectedId, setDeleteDetails);
	//	if (success) {
	//		refreshCalendarSchedule();
	//		onClose();
	//	}
	//}, [selectedId, setDeleteDetails, history]);

	//const handleRecurrencePatternDeleteClick = useCallback(() => {
	//	setConfirmRecurrencePatternDelete(true);
	//}, []);

	//const handleRecurrencePatternDeleteConfirm_Cancel = useCallback(() => {
	//	setConfirmRecurrencePatternDelete(false);
	//}, []);

	//const handleRecurrencePatternDeleteConfirm_Confirmed = useCallback(async () => {
	//	const success = await calendarScheduleService.deleteRecurrencePattern(selectedId, setDeleteDetails);
	//	if (success) {
	//		refreshCalendarSchedule();
	//		onClose();
	//	}
	//}, [selectedId, setDeleteDetails, history]);

	const isLoading = details.loading;

	return (
		<>
			<Modal show={show} onClose={onClose} showCloseButton={true} size={'large'} title="Window Details">
				{isLoading && <LoadingIndicator />}
				{details.error && <ErrorSummary error={details.error} />}
				{!isLoading && details.data && !isEditMode && (<>
					<WindowDetailsView details={details.data} />
				</>
				)}
			</Modal>
		</>
	);
};

export default WindowDetailsModal;
